import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import {
  aOrAn,
  fromSeoUrl,
  seoCountryNameToCountyCode,
  toSeoUrl,
  toPlural,
  toSingular,
} from 'helpers/HelperFunctions';
import styles from './PostJobUpsell.module.scss';

function PostJobUpsell({ mobile, role, country, city }) {
  let locationString = '';
  if (city && country) {
    locationString = ` in ${fromSeoUrl(city)}, ${fromSeoUrl(country)}`;
  } else if (country) {
    locationString = ` in ${fromSeoUrl(country)}`;
  }

  let findUrl = '/hire-a-freelancer';
  if (role && country && city) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}/${seoCountryNameToCountyCode(
      country
    )}/${toSeoUrl(city)}`;
  } else if (role && country) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}/${seoCountryNameToCountyCode(
      country
    )}`;
  } else if (role) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}`;
  }

  let title = role
    ? 'Hire ' + toPlural(fromSeoUrl(role)).toLowerCase()
    : 'Hire freelancers';
  let cta = role
    ? 'Search for ' + toPlural(fromSeoUrl(role)).toLowerCase()
    : 'Post a job';

  return (
    <div
      className={`${styles.postJobUpsellContainer} ${
        mobile ? styles.postJobUpsellMobile : styles.postJobUpsellDesktop
      }`}
    >
      <p className={styles.postJobUpsellTitle}>
        <a href={findUrl}>{title}</a>
      </p>
      <p className={styles.postJobUpsellCopy}>
        Find and{' '}
        <a href={findUrl}>
          hire{' '}
          {role
            ? aOrAn(role) + ' ' + toSingular(fromSeoUrl(role)).toLowerCase()
            : 'a freelancer'}
          {locationString}
        </a>{' '}
        to work on projects
      </p>
      <Button
        className={styles.postJobUpsellButton}
        bsStyle="success"
        href={findUrl}
      >
        {cta}
      </Button>
    </div>
  );
}

PostJobUpsell.propTypes = {
  mobile: PropTypes.bool,
};

PostJobUpsell.defaultProps = {
  mobile: false,
};

export default PostJobUpsell;
